import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html'
})
export class AppFooterComponent implements OnInit{
  public currentYear: number;

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }
}

